export const passMustHave = [/[0-9]/, /[a-z]/, /[A-Z]/];

export function passwordGrade(password) {
	let pass = password;
	if (!pass){
		return -1;
	} else {
	
		if (pass.length < 4){
			return 0;
		} 
		var s = 0;
		for (var i in passMustHave){
			if (passMustHave[i].test(pass))
				s++;
		}
		if (pass.length >= 12){
			s++;
		} 
		return s;
	}
}


// WEBPACK FOOTER //
// ./src/util/password-strength.js